import { useState, useEffect, useRef } from 'react';
import { Images } from 'assets/images';
import { useForm } from 'react-hook-form';
import { v4 as uuid } from 'uuid';
import { useOutsideClick } from 'hooks/useOutsideClick';
import {
  EditModalContainer,
  EditModalWrapper,
  EditModalBlock,
  OutlinedInput,
  InputsContainer,
  SmallOutlinedInput,
  ImageUploaderWrapper,
  ImageUpload,
  FileUploadInput,
  PlusIcon,
  InfoAboutBlock,
  AddAnother,
  AddSuggestion,
  SuggestionContainer,
  PackageSuggestionsWrapper,
  PackageSuggestionTopBlock,
  SelectFromTemplates,
  CloseIcon,
  SuggestionsBlock,
  SuggestionItem,
  SuggestionMainItem,
  SuggestionMainTitle,
  SuggestionMainDescription,
  SuggestionTitleAndDeleteButton,
  SuggestionDeleteButton,
  SuggestionDeleteWrapper,
  RightPlaceholders,
  DeleteIcon,
  PlaceholdersAndCloseIcon,
  SmallOutlinedInputParent,
} from 'admin/components/Packages/styled';
import { MenuItem } from '@mui/material';
import { Controller } from 'react-hook-form';
import {
  PLACEHOLDER_DATA,
  REACT_HOOK_FORM_NAMES,
  SUGGESTION_DATA,
} from 'admin/utils/contants';
import {
  Option,
  OptionsOfTemplates,
  SampleImage,
  SampleSpan,
  NameAndIcon,
} from 'admin/components/Offer/styled';

export const PackageEditModal = ({ editData }) => {
  const [isOpenSuggestions, setIsOpenSuggestions] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [options, setOptions] = useState(SUGGESTION_DATA);
  const [placeholderNumber, setPlaceholderNumber] = useState(0);
  const [placeholders, setPlaceholders] = useState(PLACEHOLDER_DATA);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedURL, setSelectedURL] = useState(null);
  const [selectedBackgroundFile, setSelectedBackgroundFile] = useState(null);
  const [selectedBackgroundFileUrl, setSelectedBackgroundFileUrl] = useState(null);
  const { handleSubmit, control, register } = useForm();
  const closeIconRef = useRef(null);
  const { ref, isOpen, setIsOpen } = useOutsideClick();

  useEffect(() => {
    if (selectedFile) {
      setSelectedURL(URL.createObjectURL(selectedFile));
    }
    if (selectedBackgroundFile) {
      setSelectedBackgroundFileUrl(URL.createObjectURL(selectedBackgroundFile));
    }
  }, [selectedFile, selectedBackgroundFile]);

  const addTemplate = (element) => {
    setOptions(options.filter((g) => g.id !== element.id));
    setTemplates((prev) => [...prev, element]);
  };

  const deleteSuggestion = (element) => {
    setTemplates(templates.filter((item) => item.id !== element.id));
    setOptions((prev) => [...prev, element]);
  };

  const openDropDown = () => {
    if (options.length > 0) {
      setIsOpen((prev) => !prev);
    }
  };

  const openSuggestion = (e) => {
    e.preventDefault();
    setIsOpenSuggestions(true);
  };

  const closeSuggestion = () => {
    setIsOpenSuggestions(false);
  };

  const addPlaceholder = (e) => {
    e.preventDefault();
    setPlaceholderNumber(placeholderNumber + 1);
    setPlaceholders((prev) => [
      ...prev,
      {
        placeholder: 'label placeholder',
        value: 'label value',
        id: placeholderNumber + 1,
      },
    ]);
  };

  const deletePlaceholder = (index) => {
    setPlaceholders(() => placeholders.filter((item) => item.id !== index));
  };

  const onSubmit = (data) => console.log(data);

  useEffect(() => {
    closeIconRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [isOpenSuggestions]);

  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  }, [isOpen]);

  useEffect(() => {
    if (options.length === 0) {
      setIsOpen(false);
    }
  }, [templates]);

  return (
    <EditModalWrapper>
      <EditModalBlock>
        <EditModalContainer onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="title"
            control={control}
            render={({ field }) => (
              <OutlinedInput
                id="outlined-basic"
                label="Title*"
                defaultValue={editData.title}
                onChange={(e) => field.onChange(e)}
                key={field.key}
                variant="outlined"
              />
            )}
          />

          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <OutlinedInput
                isDescription
                id="outlined-basic"
                label="Description*"
                onChange={(e) => field.onChange(e)}
                key={field.key}
                defaultValue={editData.description}
                variant="outlined"
                inputProps={{
                  autocomplete: 'new-password',
                  form: {
                    autocomplete: 'off',
                  },
                  className: 'material-ui-description',
                }}
              />
            )}
          />

          <InputsContainer>
            <Controller
              name="country"
              control={control}
              render={({ field }) => (
                <SmallOutlinedInputParent>
                  <SmallOutlinedInput
                    isSmall
                    id="outlined-basic"
                    label="Country*"
                    select
                    onChange={field.onChange}
                    key={field.key}
                    variant="outlined"
                  >
                    <MenuItem key={1} value="test">
                      Test 1
                    </MenuItem>
                    <MenuItem key={2} value="test2">
                      Test 2
                    </MenuItem>
                  </SmallOutlinedInput>

                  <SampleImage
                    backgroundWhite
                    src={Images.selectDownArrowSilverIcon}
                  />
                </SmallOutlinedInputParent>
              )}
            />
            <Controller
              name="city"
              control={control}
              render={({ field }) => (
                <SmallOutlinedInputParent>
                  <SmallOutlinedInput
                    isSmall
                    id="outlined-basic"
                    label="City*"
                    onChange={field.onChange}
                    key={field.key}
                    select
                    variant="outlined"
                  >
                    <MenuItem key={1} value="test">
                      Test 1
                    </MenuItem>
                    <MenuItem key={2} value="test2">
                      Test 2
                    </MenuItem>
                  </SmallOutlinedInput>
                  <SampleImage
                    backgroundWhite
                    src={Images.selectDownArrowSilverIcon}
                  />
                </SmallOutlinedInputParent>
              )}
            />
            <Controller
              name="stay_days"
              control={control}
              render={({ field }) => (
                <SmallOutlinedInput
                  isSmall
                  id="outlined-basic"
                  label="Stay Days*"
                  onChange={(e) => field.onChange(e)}
                  key={field.key}
                  variant="outlined"
                  type="number"
                />
              )}
            />
            <Controller
              name="stay_nights"
              control={control}
              render={({ field }) => (
                <SmallOutlinedInput
                  isSmall
                  id="outlined-basic"
                  label="Stay Nights*"
                  onChange={(e) => field.onChange(e)}
                  key={field.key}
                  variant="outlined"
                  type="number"
                />
              )}
            />

            <Controller
              name="price"
              control={control}
              render={({ field }) => (
                <SmallOutlinedInput
                  isSmall
                  id="outlined-basic"
                  label="Price*"
                  onChange={(e) => field.onChange(e)}
                  key={field.key}
                  variant="outlined"
                  type="number"
                />
              )}
            />

            <Controller
              name="population"
              control={control}
              render={({ field }) => (
                <SmallOutlinedInput
                  isSmall
                  id="outlined-basic"
                  label="Population*"
                  onChange={(e) => field.onChange(e)}
                  key={field.key}
                  variant="outlined"
                  type="number"
                />
              )}
            />

            <Controller
              name="booking_url"
              control={control}
              render={({ field }) => (
                <SmallOutlinedInput
                  isSmall
                  id="outlined-basic"
                  label="Booking URL*"
                  onChange={(e) => field.onChange(e)}
                  key={field.key}
                  variant="outlined"
                  type="text"
                />
              )}
            />

            <Controller
              name="ticket_url"
              control={control}
              render={({ field }) => (
                <SmallOutlinedInput
                  isSmall
                  id="outlined-basic"
                  label="Ticket URL*"
                  onChange={(e) => field.onChange(e)}
                  key={field.key}
                  variant="outlined"
                  type="text"
                />
              )}
            />

            <Controller
              name="language"
              control={control}
              render={({ field }) => (
                <SmallOutlinedInput
                  isFull
                  id="outlined-basic"
                  label="Language*"
                  onChange={(e) => field.onChange(e)}
                  key={field.key}
                  variant="outlined"
                  type="text"
                />
              )}
            />
          </InputsContainer>

          <ImageUploaderWrapper>
            <ImageUpload
              backgroundImage={selectedURL === null ? false : selectedURL}
            >
              <InfoAboutBlock
                backgroundImage={selectedURL === null ? false : selectedURL}
              >
                Main Image*
              </InfoAboutBlock>
              <PlusIcon
                src={
                  selectedURL === null ? Images.plusSilverIcon : Images.whitePlusIcon
                }
              />
              <FileUploadInput
                type="file"
                onChange={(e) => setSelectedFile(e.target.files[0])}
              />
            </ImageUpload>
            <ImageUpload
              backgroundImage={
                selectedBackgroundFileUrl === null
                  ? false
                  : selectedBackgroundFileUrl
              }
            >
              <InfoAboutBlock
                backgroundImage={
                  selectedBackgroundFileUrl === null
                    ? false
                    : selectedBackgroundFileUrl
                }
              >
                Background Image
              </InfoAboutBlock>
              <PlusIcon
                src={
                  selectedBackgroundFileUrl === null
                    ? Images.plusSilverIcon
                    : Images.whitePlusIcon
                }
              />
              <FileUploadInput
                type="file"
                onChange={(e) => setSelectedBackgroundFile(e.target.files[0])}
              />
            </ImageUpload>
          </ImageUploaderWrapper>

          <InputsContainer isSmall>
            <Controller
              name="placeholder"
              control={control}
              render={({ field }) => (
                <SmallOutlinedInput
                  isSmall
                  id="outlined-basic"
                  label="Placeholder(optional)"
                  onChange={(e) => field.onChange(e)}
                  key={field.key}
                  variant="outlined"
                  type="text"
                />
              )}
            />
            <Controller
              name="value"
              control={control}
              render={({ field }) => (
                <SmallOutlinedInput
                  id="outlined-basic"
                  label="Value (optional)"
                  onChange={(e) => field.onChange(e)}
                  key={field.key}
                  variant="outlined"
                  type="text"
                />
              )}
            />
            {placeholders.map((element) => (
              <PlaceholdersAndCloseIcon key={uuid()}>
                <Controller
                  name={`${REACT_HOOK_FORM_NAMES.placeholder}:${element.id}`}
                  control={control}
                  render={({ field }) => (
                    <SmallOutlinedInput
                      isSmall
                      id="outlined-basic"
                      label="Placeholder"
                      onChange={field.onChange}
                      key={field.key}
                      variant="outlined"
                      type="text"
                      {...register(
                        `${REACT_HOOK_FORM_NAMES.placeholder}:${element.id}`,
                      )}
                    />
                  )}
                />
                <RightPlaceholders>
                  <Controller
                    name={`${REACT_HOOK_FORM_NAMES.label_key}:${element.id}`}
                    control={control}
                    render={({ field }) => (
                      <SmallOutlinedInput
                        isDeleteIcon
                        id="outlined-basic"
                        label="Value"
                        onChange={(e) => field.onChange(e)}
                        key={field.key}
                        variant="outlined"
                        type="text"
                        {...register(
                          `${REACT_HOOK_FORM_NAMES.label_key}:${element.id}`,
                        )}
                      />
                    )}
                  />
                  <DeleteIcon
                    src={Images.closeSilverIcon}
                    onClick={() => deletePlaceholder(element.id)}
                  />
                </RightPlaceholders>
              </PlaceholdersAndCloseIcon>
            ))}
            <AddAnother onClick={addPlaceholder}> + Add Another </AddAnother>
          </InputsContainer>

          <SuggestionContainer>
            <AddSuggestion onClick={openSuggestion}>Add Suggestion</AddSuggestion>
          </SuggestionContainer>
        </EditModalContainer>
      </EditModalBlock>
      {isOpenSuggestions ? (
        <PackageSuggestionsWrapper>
          <PackageSuggestionTopBlock>
            <SelectFromTemplates ref={ref}>
              <NameAndIcon onClick={openDropDown}>
                <SampleSpan> Add From Template </SampleSpan>
                <SampleImage src={Images.selectDownArrowSilverIcon} />
              </NameAndIcon>

              {isOpen ? (
                <OptionsOfTemplates>
                  {options.map((element) => (
                    <Option key={uuid()}>
                      <SampleSpan>{element.title} </SampleSpan>
                      <SampleSpan onClick={() => addTemplate(element)}>+</SampleSpan>
                    </Option>
                  ))}
                </OptionsOfTemplates>
              ) : null}
            </SelectFromTemplates>

            <CloseIcon
              src={Images.closeSilverIcon}
              onClick={closeSuggestion}
              closeSuggestions
              ref={closeIconRef}
            />

            <SuggestionsBlock>
              {templates?.map((element) => (
                <SuggestionItem key={uuid()}>
                  <SuggestionMainItem />
                  <SuggestionTitleAndDeleteButton>
                    <SuggestionMainTitle>{element.title}</SuggestionMainTitle>
                    <SuggestionDeleteWrapper>
                      <SuggestionDeleteButton
                        src={Images.deleteButton}
                        onClick={() => deleteSuggestion(element)}
                      />
                    </SuggestionDeleteWrapper>
                  </SuggestionTitleAndDeleteButton>
                  <SuggestionMainDescription>
                    {element.description}
                  </SuggestionMainDescription>
                </SuggestionItem>
              ))}
            </SuggestionsBlock>
          </PackageSuggestionTopBlock>
        </PackageSuggestionsWrapper>
      ) : null}
    </EditModalWrapper>
  );
};
